module.exports = __webpack_public_path__ + "static/img/CGF.79f70853.png";